"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _EmailStatusConstants = require("crm_ui/timeline/components/events/email/EmailStatusConstants");

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _ObjectRecordAccessors = require("customer-data-objects/record/ObjectRecordAccessors");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _AssociationsMediator = require("customer-data-communicator/data/associations/AssociationsMediator");

var _DeleteObjectPrompt = _interopRequireDefault(require("customer-data-objects-ui-components/prompt/DeleteObjectPrompt"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _MultipleAssociationsSelect = _interopRequireDefault(require("customer-data-communicator/components/associations/MultipleAssociationsSelect"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _TimelineActions = _interopRequireDefault(require("crm_ui/timeline/data/actions/TimelineActions"));

var _UIColumn = _interopRequireDefault(require("UIComponents/column/UIColumn"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _timelineEventTypeHelper = require("crm_ui/timeline/helpers/timelineEventTypeHelper");

var _loggers = require("customer-data-tracking/loggers");

var _AssociationsActions = require("crm_data/associations/AssociationsActions");

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var generateI18nText = function generateI18nText(key) {
  return _react.default.createElement(_FormattedMessage.default, {
    message: "profileContentTimeline.timelineEventActions." + key
  });
};

var ASSOCIATE = 'ASSOCIATE';
var DISASSOCIATE = 'DISASSOCIATE';
var multipleAssociationPropTypes = {
  subject: _SubjectType.default
};
var propTypes = (0, _extends2.default)({
  canEdit: _propTypes.default.bool,
  className: _propTypes.default.string,
  disableDelete: _propTypes.default.bool,
  engagement: _propTypes.default.instanceOf(_EngagementRecord.default),
  extraHeaderActions: _propTypes.default.array,
  isCollapsed: _propTypes.default.bool.isRequired,
  objectTypesToAssociate: _propTypes.default.arrayOf(_ObjectTypesType.default),
  onCloseSelect: _propTypes.default.func,
  onDeleteConfirm: _propTypes.default.func,
  onOpenSelect: _propTypes.default.func,
  style: _propTypes.default.object,
  useDefaultAssociationSelect: _propTypes.default.bool,
  useDropdown: _propTypes.default.bool,
  viewOnlyActions: _propTypes.default.array
}, multipleAssociationPropTypes);
var defaultProps = {
  canEdit: true,
  disableDelete: false,
  isCollapsed: false,
  objectTypesToAssociate: [_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL, _ObjectTypes.TICKET],
  onCloseSelect: _emptyFunction.default,
  onDeleteConfirm: _emptyFunction.default,
  onOpenSelect: _emptyFunction.default,
  style: {},
  useDefaultAssociationSelect: true,
  useDropdown: false
};

var TimelineEventHeaderButtons =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineEventHeaderButtons, _PureComponent);

  function TimelineEventHeaderButtons() {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineEventHeaderButtons);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineEventHeaderButtons).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    return _this;
  }

  (0, _createClass2.default)(TimelineEventHeaderButtons, [{
    key: "isScheduledEmail",
    value: function isScheduledEmail(engagementType, engagement) {
      var status = engagement.getIn(['metadata', 'status']);
      return engagementType === _EngagementTypes.EMAIL && status === _EmailStatusConstants.SCHEDULED;
    }
  }, {
    key: "handleDeleteConfirm",
    value: function handleDeleteConfirm() {
      var _this$props = this.props,
          engagement = _this$props.engagement,
          subject = _this$props.subject,
          onDeleteConfirm = _this$props.onDeleteConfirm;
      var engagementType = engagement.getIn(['engagement', 'type']);

      if (this.isScheduledEmail(engagementType, engagement)) {
        _TimelineActions.default.deleteScheduledEmailEngagement(engagement, (0, _ObjectRecordAccessors.getObjectType)(subject), (0, _ObjectRecordAccessors.getId)(subject));
      } else {
        _TimelineActions.default.deleteTimelineEngagement(engagement, (0, _ObjectRecordAccessors.getObjectType)(subject), (0, _ObjectRecordAccessors.getId)(subject));
      }

      _loggers.CrmLogger.log('timelineCardInteraction', {
        action: 'Timeline interaction',
        subAction: 'delete event',
        eventType: (0, _timelineEventTypeHelper.getEngagementEventType)(engagement),
        type: (0, _ObjectRecordAccessors.getObjectType)(subject)
      });

      onDeleteConfirm();
    }
  }, {
    key: "handleUpdateAssociations",
    value: function handleUpdateAssociations(type, objectType, subjectId) {
      _loggers.CrmLogger.log('timelineCardInteraction', {
        action: 'Timeline interaction',
        subAction: type.toLowerCase() + " " + objectType.toLowerCase(),
        eventType: (0, _timelineEventTypeHelper.getEngagementEventType)(this.props.engagement),
        type: (0, _ObjectRecordAccessors.getObjectType)(this.props.subject)
      });

      if (type === ASSOCIATE) {
        return (0, _AssociationsActions.associate)((0, _ObjectRecordAccessors.getId)(this.props.engagement), (0, _immutable.List)([subjectId]), _ObjectTypes.ENGAGEMENT, objectType);
      }

      return (0, _AssociationsActions.disassociate)((0, _ObjectRecordAccessors.getId)(this.props.engagement), subjectId, _ObjectTypes.ENGAGEMENT, objectType);
    }
  }, {
    key: "handleDeleteClick",
    value: function handleDeleteClick() {
      var engagement = this.props.engagement;
      var engagementType = engagement.getIn(['engagement', 'type']);

      if (this.isScheduledEmail(engagementType, engagement)) {
        return (0, _DeleteObjectPrompt.default)({
          callback: this.handleDeleteConfirm,
          message: generateI18nText('cancelEmail.message'),
          title: generateI18nText('cancelEmail.title'),
          confirmLabel: generateI18nText('cancelEmail.confirm')
        });
      }

      return (0, _DeleteObjectPrompt.default)({
        callback: this.handleDeleteConfirm,
        message: generateI18nText('deleteMessage'),
        title: generateI18nText('deleteTitle'),
        confirmLabel: generateI18nText('delete')
      });
    }
  }, {
    key: "renderAssociations",
    value: function renderAssociations() {
      var _this$props2 = this.props,
          engagement = _this$props2.engagement,
          subject = _this$props2.subject,
          objectTypesToAssociate = _this$props2.objectTypesToAssociate;

      if (!engagement || !this.props.useDefaultAssociationSelect || !subject) {
        return null;
      }

      var subjectId;

      try {
        subjectId = (0, _ObjectRecordAccessors.getId)(subject);
      } catch (e) {
        return null;
      }

      var associations = engagement && engagement.get('associations');

      if (!associations) {
        return null;
      }

      return _react.default.createElement(_UIColumn.default, null, _react.default.createElement(_MultipleAssociationsSelect.default, {
        className: "p-top-1 p-x-0 p-bottom-1",
        onCloseSelect: this.props.onCloseSelect,
        onOpenSelect: this.props.onOpenSelect,
        handleRemove: this.partial(this.handleUpdateAssociations, DISASSOCIATE),
        handleSelect: this.partial(this.handleUpdateAssociations, ASSOCIATE),
        objectType: (0, _ObjectRecordAccessors.getObjectType)(subject),
        subject: subject,
        subjectId: subjectId && "" + subjectId,
        values: (0, _AssociationsMediator.convertAssociationsMapToValues)(associations),
        objectTypesToAssociate: objectTypesToAssociate
      }));
    }
  }, {
    key: "renderDeleteButton",
    value: function renderDeleteButton() {
      return _react.default.createElement(_UIButton.default, {
        use: this.props.useDropdown ? '' : 'link',
        onClick: this.handleDeleteClick,
        "data-selenium-test": "timeline-header-actions__delete"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "profileContentTimeline.timelineEventActions.delete"
      }));
    }
  }, {
    key: "renderDelete",
    value: function renderDelete() {
      if (!this.props.engagement || this.props.disableDelete) {
        return null;
      }

      return _react.default.createElement(_UIColumn.default, {
        className: "p-left-4",
        key: "header-button--delete"
      }, this.renderDeleteButton());
    }
  }, {
    key: "renderExtraActions",
    value: function renderExtraActions(extraActions) {
      if (!extraActions) {
        return null;
      }

      return extraActions.map(function (action, idx) {
        return _react.default.createElement(_UIColumn.default, {
          className: "p-left-4",
          key: "extra-header-action-" + idx
        }, action);
      });
    }
  }, {
    key: "renderDropdown",
    value: function renderDropdown() {
      var _this2 = this;

      var DropdownContent = function DropdownContent() {
        return _react.default.createElement(_UIList.default, null, _this2.props.extraHeaderActions, _this2.renderDeleteButton());
      };

      var buttonText = _react.default.createElement(_FormattedMessage.default, {
        message: "profileContentTimeline.actions"
      });

      return _react.default.createElement(_UIColumn.default, {
        className: "p-left-4"
      }, _react.default.createElement(_UIDropdown.default, {
        buttonText: buttonText,
        buttonUse: "link",
        Content: DropdownContent
      }));
    }
  }, {
    key: "renderExtraActionsAndDelete",
    value: function renderExtraActionsAndDelete() {
      if (this.props.useDropdown) {
        return this.renderDropdown();
      }

      return [this.renderExtraActions(this.props.extraHeaderActions), this.renderDelete()];
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.canEdit) {
        return this.props.viewOnlyActions ? _react.default.createElement(_UIColumn.default, {
          className: this.props.className,
          "data-collapsed": this.props.isCollapsed,
          style: this.props.style,
          "data-unit-test": "timeline-header-actions--read-only"
        }, this.renderExtraActions(this.props.viewOnlyActions)) : null;
      }

      return _react.default.createElement(_UIColumn.default, {
        className: this.props.className,
        "data-selenium-test": "timeline-header-actions",
        "data-unit-test": "timeline-header-actions",
        "data-collapsed": this.props.isCollapsed,
        style: this.props.style
      }, this.renderAssociations(), this.renderExtraActionsAndDelete());
    }
  }]);
  return TimelineEventHeaderButtons;
}(_PureComponent2.default);

TimelineEventHeaderButtons.propTypes = propTypes;
TimelineEventHeaderButtons.defaultProps = defaultProps;
var _default = TimelineEventHeaderButtons;
exports.default = _default;
module.exports = exports.default;